import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconReport24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconReport24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 3.5h10A1.5 1.5 0 0 1 18.5 5v14a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 19V5A1.5 1.5 0 0 1 7 3.5M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm4 1a.75.75 0 0 0 0 1.5h7.2a.75.75 0 0 0 0-1.5zm-.75 3.75A.75.75 0 0 1 8 9h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m3.881 3.819-.526-.519-.527.519-2.81 2.768a.75.75 0 0 0 1.053 1.069l2.284-2.25 2.284 2.25.526.518.526-.518 2.81-2.768a.75.75 0 0 0-1.052-1.07l-2.284 2.25z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconReport24);
